
import matchDetailIcon from 'assets/icons/icon-match-detail@3x.png'

import imgBannerPrompt from 'assets/banner-prompt@3x.png'

import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'

import { CardItem, MatchCard } from '../Common/Card'

import QuestionCell from '../Common/QuestionCell.vue'
import PriceTable from '../Common/PriceTable.vue'
import meiqia from '../../utils/meiqia'

import { mapState, mapActions } from 'vuex'

import routeHelper from '../../utils/route-helper.js'
import videoPlay from '../../utils/video-play.js'

export default {
name: 'MatchDetail',
components: {
XHeader,
XButton,
Card,
Previewer,
QuestionCell,
PriceTable,
CardItem,
MatchCard,
},
data() {
return {
matchDetailIcon,
imgBannerPrompt,
imgList: [],
matches: [],
}
},
computed: {
...mapState({
match: ({ match }) => match.introduction,
}),
homePageRoute() {
return routeHelper.homePageRoute()
},
tickets() {
if (!this.match.isMultiScene && this.match.scenes.length > 0) {
return this.match.scenes[0].tickets
}
return []
},
orderAble() {

return (this.match.saleStatus === 2 || this.match.saleStatus === 3
|| this.match.saleStatus === 6) && this.match.deliveryInfo
},
matchStatus() {
const saleStatus = {
1: 'not-open',
2: 'on-sale',
3: 'presale',
4: 'closed',
5: 'sold-out',
6: 'purchasing',
}
return saleStatus[this.match.saleStatus]
},
matchStatusText() {
const saleStatus = {
1: '未开售',
2: '售票中',
3: '预售',
4: '已停售',
5: '售罄',
6: '代购中',
}
return saleStatus[this.match.saleStatus]
},
submitBtnText() {
switch (this.match.saleStatus) {
case 2:
case 6:
case 3: {
if (!this.match.deliveryInfo) {
return '该赛事暂无配送信息'
}
return '立即预订'
}
case 4:
return '已停售'
case 5:
return '售罄'
case 1:
default:
return '未开售'
}
},
fromShare() {
const url = window.location.search
if (url.indexOf('?') !== -1) {
const queryString = url.substr(1)
return queryString.split('=')[1] === 'share'
}
return false
},
},
methods: {
...mapActions(['fetchMatchIntroduction', 'toggleMatchFavour', 'showToast']),
gotoOrderConfirm() {
this.$router.push({
name: 'order-confirm',
params: {
matchId: this.$route.params.matchId,
from: 'matchDetail',
},
})
},
generateImgList() {
const images = document.querySelectorAll('.match-detail-card img')
return Array.from(images).map(img => ({
src: img.src,
w: img.getAttribute('data-width') || 600,
h: img.getAttribute('data-height') || 400,
}))
},
popUpImg(event) {
if (event.target.tagName === 'IMG') {

const idx = this.imgList.map(im => im.src).indexOf(event.target.src)
this.$refs.previewer.show(idx !== -1 ? idx : 0)
}
},
initialWeixinShare() {
const { wx } = window
const { match } = this
if (wx) {
wx.ready(() => {
const shareInfo = {
title: `[${match.league && match.league.name}]${match.title}`,
desc: '《观赛日》全球体育赛事门票预定',
link: window.location.href,

imgUrl: '//qncommon.saiday.com/yoyo/common/share_icon.png',
}

wx.onMenuShareAppMessage(shareInfo)
wx.onMenuShareTimeline(shareInfo)
})
}
},
addToFavour() {
if (this.$jwt.userId) {
const { matchId } = this.$route.params
this.toggleMatchFavour({ matchId, add: !this.match.isFavorite })
.then(() => {
const content = `${!this.match.isFavorite ? '收藏成功' : '已取消'}`
this.showToast({ content })
})
} else {
this.showToast({ content: '请先登录' })
routeHelper.redirectToLogin(this.$router, this.$route.path)
}
},
getRecommendMatchs(matchId) {
if (this.match && this.match.league && this.match.league.isOversea) {
return
}
this.$http.get(`/api/match/recommendList/${matchId}`).then((res) => {
this.matches = res.data.matches
})
},
reload() {
this.$router.go(0)
},
},
created() {
meiqia.init(this.$route.name)
const to = this.$route
document.title = '赛事详情'
this.fetchMatchIntroduction({
matchId: to.params.matchId,
userId: this.$jwt.userId,
}).then(() => {
this.imgList = this.generateImgList()
this.match.videosArray.forEach((video) => {
const cover = video.cover ? video.cover.url : ''
videoPlay(video.id, video.url, cover)
})
this.initialWeixinShare()
this.getRecommendMatchs(to.params.matchId)
}).catch((err) => {
this.showToast({
content: err.body.resultInfo,
})
setTimeout(() => {
window.history.back()
}, 1000)
})
},
watch: {
'$route': 'reload' // eslint-disable-line
},
}



// WEBPACK FOOTER //
// ./client/components/Match/MatchDetail.vue